import ChatRightPanel from './ChatRightPanel';

export default ChatRightPanel;
